import HistoryStatus from "@/enum/HistoryStatus";
import PaymentStatus from "@/enum/PaymentStatus";

// Tentativas do processamento automático antes de precisar do operador (mesma regra do Status.vue)
const MAX_PROCESS_ATTEMPTS = 2;
// Tolerância de arredondamento ao comparar valores do pagamento e do histórico
const VALUE_TOLERANCE = 0.01;
// Abaixo disso a devolução é esperada (o backend cancela quando o valor calculado é pequeno)
const RETURNED_MIN_CONSUMPTION = 1;

export function money(value) {
    return `R$ ${Number(value).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

const STATUS_LABELS = {
    [PaymentStatus.OK]: "Autorizado",
    [PaymentStatus.WAIT]: "Aguardando",
    [PaymentStatus.FINISH]: "Finalizado",
    [PaymentStatus.CANCELED]: "Cancelado",
    [PaymentStatus.REFUND]: "Estornado",
    [PaymentStatus.ERROR]: "Erro",
    [PaymentStatus.ERROR_ON_FINISH]: "Erro ao finalizar",
};

export function paymentStatusLabel(status) {
    return STATUS_LABELS[status] || status || "-";
}

// Mesma regra do backend (enum/PaymentStatus.isProcessed)
export function isProcessed(status) {
    return status == PaymentStatus.FINISH || PaymentStatus.isReturned(status) || status == PaymentStatus.ERROR_ON_FINISH;
}

// Alertas de possíveis problemas em um pagamento, os críticos precisam de ação. Usado nas telas de
// Pagamentos e Carregamentos via Aplicativo, por isso recebe o pagamento com chargerHistory/carChargeData
export function paymentAlerts(payment) {
    const value = Number(payment.value) || 0;
    const history = payment.chargerHistory;
    const session = payment.carChargeData;
    const alerts = [];
    const add = (key, text, critical = false) => alerts.push({ key, text, critical });

    if (!history && !session && !PaymentStatus.isReturned(payment.status)) {
        add("unlinked", "Pagamento não associado a um carregamento", true);
    }
    if (PaymentStatus.isReturned(payment.status) && value > 0) {
        add("returnedWithValue", "Devolvido, mas o valor deveria ser zero", true);
    }
    if (!payment.config) {
        add("withoutConfig", "Configuração não localizada", true);
    }
    if (payment.status == PaymentStatus.ERROR) {
        add("operatorError", "Erro retornado pela operadora");
    }
    if (payment.status == PaymentStatus.ERROR_ON_FINISH) {
        add("finishError", "Erro ao finalizar/devolver na operadora", true);
    }
    if (session && session.errorSession) {
        add("sessionError", "Sessão com erro, aguardando 'StopTransaction'");
    }

    if (history) {
        if (history.status == HistoryStatus.NEED_PROCESS && history.counter >= MAX_PROCESS_ATTEMPTS) {
            add("operatorAction", "Processamento falhou, necessária ação do operador", true);
        }
        if (history.status == HistoryStatus.PROCESSED_MANUAL_ERROR) {
            add("validateOperator", "Validar com a plataforma oficial da operadora", true);
        }
        if (history.status == HistoryStatus.PROCESSED && !isProcessed(payment.status)) {
            add("notFinished", "Histórico processado, mas o pagamento não foi finalizado", true);
        }
        if (payment.status == PaymentStatus.FINISH && value > 0 && !(history.consumption > 0)) {
            add("chargedWithoutConsumption", "Cobrado sem consumo registrado", true);
        }
        if (PaymentStatus.isReturned(payment.status) && history.consumption >= RETURNED_MIN_CONSUMPTION) {
            add("returnedWithConsumption", `Consumo de ${Number(history.consumption).toFixed(2)} kWh, mas o pagamento foi devolvido`);
        }
        if (payment.status == PaymentStatus.FINISH && history.paymentValue != null && Math.abs(Number(history.paymentValue) - value) >= VALUE_TOLERANCE) {
            add("valueMismatch", `Valor cobrado (${money(value)}) diferente do histórico (${money(history.paymentValue)})`);
        }
    }

    return alerts;
}
